import { FusionLayout } from "@/parts/fusion-layout";
import React from "react";
import { useTranslation } from "react-i18next";
import { Section } from "src/ui/atoms/section";
import { ListStationaryUnits } from "src/ui/molecules/list-stationary-units";
import { createUuid } from "src/utils/uuid";
import sizes from "../ui/sizes.scss";
import { observer } from "mobx-react";
import { Stack } from "@fluentui/react";
import { ListCommandButtonsStationaryUnits } from "src/ui/organisms/list-command-buttons-stationary-units";

export const PageStationaryUnits = observer((): JSX.Element => {
    const { t } = useTranslation();
    const stationaryUnitListStateId = createUuid();

    return (
        <FusionLayout breadcrumb={t("page.stationaryUnits.title")} classic>
            <Section fill>
                <ListStationaryUnits
                    commandBar={
                        <Stack horizontal style={{ alignItems: "center" }}>
                            <ListCommandButtonsStationaryUnits
                                listStateId={stationaryUnitListStateId}
                            />
                        </Stack>
                    }
                    listStateId={stationaryUnitListStateId}
                    maxHeight={sizes.listMaxHeight}
                />
            </Section>
        </FusionLayout>
    );
});
